import React from 'react';

export default function About() {
  return (
    <div>
      <h1>About Page</h1>
      <p>
      My name is Chris Duhaime. I am going to school to be a full stack Web Developer. Throughout my career I
            have had a wide range of jobs from construction to accounting and investments. I enjoy a variety of
            outdoor activities like kayaking and mountain biking. I have a BS in Business Management from Southern
            New Hampshire University.  I am currently a student at UNH Coding Bootcamp Full Stack.
      </p>
      <img className="mx-auto d-block border"  src="images/profile pic.png" alt="profile pic"></img>
    </div>
  );
}
